import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

import { MerchandisingHeader } from 'routes/Menu/MenuRecipesPage/CollectionHeader/CollectionHeaderWrapper/MerchandisingHeader'
import { AccountOnHoldAlert } from 'routes/Menu/components/AccountOnHold/AccountOnHoldAlert'
import { FlexOrderAlert } from 'routes/Menu/components/Flex/FlexOrderAlert'
import type { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

type CollectionHeaderProps = {
  showAccountOnHoldAlert: boolean
  isFlexOrder: boolean
  showMerchandisingBanner: boolean
  merchandisingHeader?: MenuHeadersIncludesData | null
}

const CustomBox = withCitrusTheme(Box, () => ({
  marginTop: '0',
  marginBottom: '0',
}))

export const CollectionHeader = ({
  showAccountOnHoldAlert,
  isFlexOrder,
  showMerchandisingBanner,
  merchandisingHeader,
}: CollectionHeaderProps) => {
  if (showAccountOnHoldAlert) {
    return (
      <CustomBox>
        <AccountOnHoldAlert />
      </CustomBox>
    )
  }

  if (isFlexOrder) {
    return (
      <CustomBox>
        <FlexOrderAlert />
      </CustomBox>
    )
  }

  if (showMerchandisingBanner) {
    return (
      <Box paddingBottom={12}>
        <MerchandisingHeader header={merchandisingHeader} />
      </Box>
    )
  }

  return null
}
